import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFinish", "children", "currentTime"];
import { VideoControls } from './VideoControls';
import { VideoPlayer, VideoPlayerProvider } from './VideoPlayer';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import { create } from 'zustand';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useCurrentVideoTime = create(set => ({
  currentVideoTime: 0,
  setCurrentVideoTime: time => set(() => ({
    currentVideoTime: time
  }))
}));
export const VideoPlayerWithControls = _ref => {
  let {
      onFinish,
      children,
      currentTime
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    setCurrentVideoTime
  } = useCurrentVideoTime();
  useEffect(() => {
    setCurrentVideoTime(currentTime || 0);
  }, [currentTime, setCurrentVideoTime]);
  return /*#__PURE__*/_jsx(VideoPlayerProvider, {
    children: /*#__PURE__*/_jsxs(VideoPlayer, Object.assign({
      onFinish: onFinish,
      onTimeUpdate: time => setCurrentVideoTime(time)
    }, props, {
      children: [/*#__PURE__*/_jsx(ContentControlWrapper, {
        children: /*#__PURE__*/_jsx(VideoControls, {
          onFinish: onFinish
        })
      }), children]
    }))
  });
};
export default VideoPlayerWithControls;